/**
 *
 * @param {object} serviceData
 * @param {object|null} modal
 * @param {object} config
 * @description
 *
 * Не показываем:
 * Для Subscription
 * Если в конфиге start_count = false
 * Если не выбран провайдер
 * Если ошибка в провайдере
 *
 * Показываем:
 * Mode === 0 - Всегда показываем
 * Mode === 1
 * Если выбран провайдер и у него start_count = true
 *
 *
 * @returns {boolean}
 */
export default (serviceData, modal, config) => {
  // TODO PNL-9833
  // Разрешили Start count parsing для Subscription услуг
  // const isSubscription = checkModalSubscription(modal);
  // const isProviderServiceSubscription = checkProviderServiceSubscription(serviceData?.form, serviceData?.providerForm);
  const isStartCount = config?.start_count;
  const form = serviceData?.form;
  const isLoadingProvider = serviceData?.isLoadingProvider
  const errorProvider = serviceData?.errorProvider

  if (isStartCount) {
    if (form) {
      const { provider_id, mode } = form;

      if (mode === 1) {
        if (isLoadingProvider) {
          return false;
        }
        if (errorProvider) {
          return false;
        }
        if (provider_id) {
          return true;
        }
      }

      if (mode === 0) {
        return true;
      }
    }
  }

  return false;
};
